<template>
  <div class="container" @click="viewClick()">
    <div class="wrap">

      <van-image v-if="state==1" :src="require('../../../assets/imgs/ic_tip_fail.png')"/>
      <van-loading v-if="state==0" color="#1989fa"/>
      <label>{{ msg }}</label>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Loading, Image} from 'vant';

Vue.use(Loading);
Vue.use(Image)
export default {

  data: () => {
    return {
      msg: '加载中...'
    };
  },
  props: ['state'],//0加载中。。,1报错，2数据为空
  name: "EmptyLayout",
  computed: {},
  watch: {
    state(val) {
      switch (val) {
        case 0:
          this.msg = "加载中..."
          break
        case 1:
          this.msg = "网络错误..."
          break
        case 2:
          this.msg = "暂无数据..."
          break
      }
    }
  },
  methods: {
    viewClick() {
      switch (this.state) {
        case 1:
        case 2:
          this.$emit('emptyClick')
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/utils/comm.less";

.container {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .wrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 140px;
      height: 140px;
    }

    label {
      font-size: 20px;
      color: #999999;
    }
  }
}


</style>
